import { ArrowLeft, TrendingUp, TrendingDown, DollarSign, Repeat } from 'lucide-react';
import { motion } from 'framer-motion';

interface Props { onBack?: () => void; }

export function AnalyticsDashboard({ onBack = () => window.history.back() }: Props) {
  const stats = [
    { label: 'Total Items', value: '47', icon: null, color: '#6C3CE1' },
    { label: 'Total Value', value: '$3,240', icon: DollarSign, color: '#6C3CE1' },
    { label: 'Avg Cost/Wear', value: '$4.20', icon: TrendingDown, color: '#22C55E' },
    { label: 'Most Versatile', value: 'Navy Blazer', icon: Repeat, color: '#FF6B5A' },
  ];

  const mostWorn = [
    { name: 'White T-Shirt', count: 24, cpw: '$0.83' },
    { name: 'Dark Jeans', count: 18, cpw: '$2.78' },
    { name: 'Navy Blazer', count: 15, cpw: '$8.67' },
    { name: 'Sneakers', count: 20, cpw: '$4.50' },
  ];

  const leastWorn = [
    { name: 'Red Dress', count: 1, cpw: '$85.00', days: 45 },
    { name: 'Leather Boots', count: 2, cpw: '$47.50', days: 38 },
    { name: 'Silk Scarf', count: 0, cpw: 'N/A', days: 60 },
  ];

  return (
    <div className="flex flex-col h-full bg-[#FAFAF8]">
      <div className="flex items-center gap-3 px-4 py-3">
        <button onClick={onBack} className="p-2 rounded-lg hover:bg-gray-100"><ArrowLeft size={20} /></button>
        <h2 className="font-semibold">Wardrobe Analytics</h2>
      </div>
      <div className="flex-1 px-4 pb-24 overflow-y-auto space-y-4">
        <div className="grid grid-cols-2 gap-3">
          {stats.map(s => (
            <div key={s.label} className="bg-white p-4 rounded-xl">
              <p className="text-xs text-gray-400">{s.label}</p>
              <p className="text-xl font-bold mt-1" style={{ color: s.color }}>{s.value}</p>
            </div>
          ))}
        </div>
        <div className="bg-white p-4 rounded-xl">
          <h3 className="font-medium text-sm mb-3 flex items-center gap-2"><TrendingUp size={16} className="text-green-500" /> Most Worn</h3>
          {mostWorn.map((item, i) => (
            <div key={item.name} className="flex items-center justify-between py-2 border-b last:border-0">
              <div className="flex items-center gap-2">
                <span className="text-xs text-gray-400 w-4">{i + 1}</span>
                <span className="text-sm">{item.name}</span>
              </div>
              <div className="text-right">
                <span className="text-sm font-medium">{item.count}x</span>
                <span className="text-xs text-gray-400 ml-2">{item.cpw}/wear</span>
              </div>
            </div>
          ))}
        </div>
        <div className="bg-white p-4 rounded-xl">
          <h3 className="font-medium text-sm mb-3 flex items-center gap-2"><TrendingDown size={16} className="text-red-500" /> Needs Attention</h3>
          {leastWorn.map(item => (
            <div key={item.name} className="flex items-center justify-between py-2 border-b last:border-0">
              <div>
                <span className="text-sm">{item.name}</span>
                <p className="text-xs text-gray-400">Unworn for {item.days} days</p>
              </div>
              <span className="text-xs text-red-400">{item.count}x worn</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
